var map = {
	"./Acer Chromebook.png": 511,
	"./Acer Iconia Tab A.png": 512,
	"./Acer Picasso.png": 513,
	"./Acer S277HK.png": 514,
	"./Acer Switch 10 E.png": 515,
	"./Ainol Novo 10 Hero.png": 516,
	"./Ainol Novo 7 Crystal.png": 517,
	"./Ainol Novo 9 Spark.png": 518,
	"./Alcatel One Touch Idol Ultra.png": 519,
	"./Alcatel One Touch Ultra 995.png": 520,
	"./Amazon Fire HD 10.png": 521,
	"./Amazon Fire HD 6.png": 522,
	"./Amazon Fire HD 8.png": 523,
	"./Amazon Fire.png": 524,
	"./Amazon Kindle Fire 1st Gen.png": 525,
	"./Amazon Kindle Fire HD 7.png": 526,
	"./Amazon Kindle Fire HD 8.9.png": 527,
	"./Apple Cinema Display 30.png": 528,
	"./Apple MacBook 12-inch.png": 529,
	"./Apple MacBook Air 11-inch (Late 2010 - Mid 2012).png": 530,
	"./Apple MacBook Air 11-inch.png": 531,
	"./Apple MacBook Air 13-inch (Late 2010 - Mid 2012).png": 532,
	"./Apple MacBook Air 13-inch.png": 533,
	"./Apple MacBook Pro 13-inch (Mid 2009 - Mid 2012).png": 534,
	"./Apple MacBook Pro 13-inch.png": 535,
	"./Apple MacBook Pro 15-inch (Hi-Res screen).png": 536,
	"./Apple MacBook Pro 15-inch.png": 537,
	"./Apple Thunderbolt Display 27.png": 538,
	"./Apple iMac 21.5-inch (Late 2009 - Late 2012).png": 539,
	"./Apple iMac 27-inch (Late 2009 - Late 2012).png": 540,
	"./Apple iPad 1 and 2.png": 541,
	"./Apple iPad 10.2 (2020).png": 542,
	"./Apple iPad 3 and 4.png": 543,
	"./Apple iPad Air (2019).png": 544,
	"./Apple iPad Air (2020).png": 545,
	"./Apple iPad Air 2.png": 546,
	"./Apple iPad Air.png": 547,
	"./Apple iPad Mini (2019).png": 548,
	"./Apple iPad Mini 2.png": 549,
	"./Apple iPad Mini 4.png": 550,
	"./Apple iPad Mini.png": 551,
	"./Apple iPad Pro 10.5.png": 552,
	"./Apple iPad Pro 11.png": 553,
	"./Apple iPad Pro 12.9.png": 554,
	"./Apple iPad Pro 9.7.png": 555,
	"./Apple iPad Pro.png": 556,
	"./Apple iPhone 11 Pro Max.png": 557,
	"./Apple iPhone 11 Pro.png": 558,
	"./Apple iPhone 11.png": 559,
	"./Apple iPhone 12 Mini.png": 560,
	"./Apple iPhone 12 Pro Max.png": 561,
	"./Apple iPhone 12 Pro.png": 562,
	"./Apple iPhone 12.png": 563,
	"./Apple iPhone 3GS.png": 564,
	"./Apple iPhone 4 (4, 4S).png": 565,
	"./Apple iPhone 5 (5c, 5s).png": 566,
	"./Apple iPhone 6 Plus.png": 567,
	"./Apple iPhone 6.png": 568,
	"./Apple iPhone 6s.png": 569,
	"./Apple iPhone 7 Plus.png": 570,
	"./Apple iPhone 7.png": 571,
	"./Apple iPhone 8 Plus.png": 572,
	"./Apple iPhone 8.png": 573,
	"./Apple iPhone SE 2020.png": 574,
	"./Apple iPhone SE.png": 575,
	"./Apple iPhone X.png": 576,
	"./Apple iPhone XR.png": 577,
	"./Apple iPhone XS Max.png": 578,
	"./Apple iPhone XS.png": 579,
	"./Asus Chrombook Flip.png": 580,
	"./Asus K55N-DS81 15.6 in.png": 581,
	"./Asus Nexus 7 (2013).png": 582,
	"./Asus Nexus 7.png": 583,
	"./Asus PB287Q.png": 584,
	"./Asus ROG G751JL-BSI7T28.png": 585,
	"./Asus Transformer.png": 586,
	"./Asus ZenBook UX305.png": 587,
	"./Asus ZenPad 8.0.png": 588,
	"./Asus Zenfone 2 Laser ZE500KL.png": 589,
	"./Asus Zenfone Max ZC550KL.png": 590,
	"./Barnes and Noble Nook Tablet.png": 591,
	"./BlackBerry BlackBerry Priv.png": 592,
	"./BlackBerry Classic Non Camera.png": 593,
	"./BlackBerry Leap.png": 594,
	"./BlackBerry Passport.png": 595,
	"./BlackBerry PlayBook.png": 596,
	"./BlackBerry Porsche Design P9982.png": 597,
	"./BlackBerry Priv.png": 598,
	"./BlackBerry Q10.png": 599,
	"./BlackBerry Torch 9810.png": 600,
	"./BlackBerry Z10.png": 601,
	"./BlackBerry Z3.png": 602,
	"./Dell Inspiron 14 series 36.png": 603,
	"./Dell Inspiron 15 5000 Series.png": 604,
	"./Dell S2340M 23.png": 605,
	"./Dell U2713HM 27.png": 606,
	"./Dell UltraSharp U2412M 24.png": 607,
	"./Dell UltraSharp U2711 27.png": 608,
	"./Dell UltraSharp U3011 30.png": 609,
	"./Dell UltraSharp UZ2315H.png": 610,
	"./Dell Venue 10.png": 611,
	"./Dell Venue.png": 612,
	"./Dell XPS 13.png": 613,
	"./FUJITSU LIFEBOOK U745.png": 614,
	"./FUJITSU STYLISTIC Q665.png": 615,
	"./FUJITSU STYLISTIC Q736.png": 616,
	"./Google Chromebook Pixel.png": 617,
	"./Google Pixel C.png": 618,
	"./Google Pixel XL.png": 619,
	"./Google Pixel.png": 620,
	"./HP 7 Plus Tablet.png": 621,
	"./HP 7 Voice Tab.png": 622,
	"./HP Dreamcolor Z27x.png": 623,
	"./HP Pavilion G6-2235us 15.6.png": 624,
	"./HP Slate 7.png": 625,
	"./HP Slate 8 Plus Tablet.png": 626,
	"./HP Slate7 VoiceTab.png": 627,
	"./HTC Desire HD.png": 628,
	"./HTC Desire.png": 629,
	"./HTC Evo.png": 630,
	"./HTC Nexus 9.png": 631,
	"./HTC One M8.png": 632,
	"./HTC One M9.png": 633,
	"./HTC One.png": 634,
	"./Huawei Mat.png": 635,
	"./Huawei Nexus 6p.png": 636,
	"./Huawei Nova 7i.png": 637,
	"./Huawei P8.png": 638,
	"./Infocus M812i.png": 639,
	"./LG G3.png": 640,
	"./LG G4.png": 641,
	"./LG GX F310L.png": 642,
	"./LG Nexus 4 AR.png": 643,
	"./LG Nexus 4.png": 644,
	"./LG Nexus 5X.png": 645,
	"./LG Phoenix 2.png": 646,
	"./LG V10.png": 647,
	"./Lenovo K3 Note.png": 648,
	"./Lenovo Thinkpad X230.png": 649,
	"./Lenovo Vibe K4 Note.png": 650,
	"./Lenovo Yoga 10 HD+.png": 651,
	"./Micromax Canvas 6.png": 652,
	"./Microsoft Lumia 950.png": 653,
	"./Microsoft Surface Book.png": 654,
	"./Microsoft Surface Pro (2017).png": 655,
	"./Microsoft Surface Pro 3.png": 656,
	"./Microsoft Surface Pro 4.png": 657,
	"./Motorola Droid 3 and 4.png": 658,
	"./Motorola Droid Razr Maxx.png": 659,
	"./Motorola Droid Razr.png": 660,
	"./Motorola Droid Turbo.png": 661,
	"./Motorola Droid.png": 662,
	"./Motorola Moto E.png": 663,
	"./Motorola Moto G.png": 664,
	"./Motorola Moto G4 Plus.png": 665,
	"./Motorola Moto X Style.png": 666,
	"./Motorola Moto Z.png": 667,
	"./Motorola Nexus 6.png": 668,
	"./Nokia Lumia (710, 800).png": 669,
	"./Nokia Lumia 1020.png": 670,
	"./Nokia Lumia 520.png": 671,
	"./Nokia Lumia 620.png": 672,
	"./Nokia Lumia 720.png": 673,
	"./Nokia Lumia 900.png": 674,
	"./Nokia Lumia 920.png": 675,
	"./Nokia Lumia 925.png": 676,
	"./OnePlus 2.png": 677,
	"./OnePlus One.png": 678,
	"./OnePlus X.png": 679,
	"./Oppo A37.png": 680,
	"./Oppo A53.png": 681,
	"./Oppo A59.png": 682,
	"./Oppo F1 Plus.png": 683,
	"./Oppo F1.png": 684,
	"./Oppo R9 Plus.png": 685,
	"./Oppo R9.png": 686,
	"./Panasonic BT-4LH310.png": 687,
	"./Panasonic BT-4LH310P.png": 688,
	"./Panasonic BT-LH1850.png": 689,
	"./Panasonic BT-LH910.png": 690,
	"./Panasonic Eluga Arc.png": 691,
	"./Panasonic Eluga I3.png": 692,
	"./Panasonic T44.png": 693,
	"./Panasonic T50.png": 694,
	"./Panasonic Toughpad FZ-F1.png": 695,
	"./Philips Sapphire Life V787.png": 696,
	"./Philips Sapphire S616.png": 697,
	"./Samsung A5.png": 698,
	"./Samsung Chromebook.png": 699,
	"./Samsung Galaxy A30.png": 700,
	"./Samsung Galaxy A50.png": 701,
	"./Samsung Galaxy A50s.png": 702,
	"./Samsung Galaxy A51.png": 703,
	"./Samsung Galaxy A70s.png": 704,
	"./Samsung Galaxy A71.png": 705,
	"./Samsung Galaxy J7 Prime.png": 706,
	"./Samsung Galaxy J7 Prime2.png": 707,
	"./Samsung Galaxy J7.png": 708,
	"./Samsung Galaxy Nexus.png": 709,
	"./Samsung Galaxy Note II.png": 710,
	"./Samsung Galaxy Note Pro 12.2.png": 711,
	"./Samsung Galaxy Note.png": 712,
	"./Samsung Galaxy Note10+.png": 713,
	"./Samsung Galaxy Note10.png": 714,
	"./Samsung Galaxy Note20 Ultra.png": 715,
	"./Samsung Galaxy Note20.png": 716,
	"./Samsung Galaxy Note4.png": 717,
	"./Samsung Galaxy Note5.png": 718,
	"./Samsung Galaxy S Plus.png": 719,
	"./Samsung Galaxy S.png": 720,
	"./Samsung Galaxy S10 Lite.png": 721,
	"./Samsung Galaxy S20 Ultra.png": 722,
	"./Samsung Galaxy S20+.png": 723,
	"./Samsung Galaxy S5.png": 724,
	"./Samsung Galaxy S6 Edge+.png": 725,
	"./Samsung Galaxy S6.png": 726,
	"./Samsung Galaxy S7 Edge.png": 727,
	"./Samsung Galaxy S7.png": 728,
	"./Samsung Galaxy S8+.png": 729,
	"./Samsung Galaxy S8.png": 730,
	"./Samsung Galaxy SII.png": 731,
	"./Samsung Galaxy SIII.png": 732,
	"./Samsung Galaxy SIV.png": 733,
	"./Samsung Galaxy SV.png": 734,
	"./Samsung Galaxy Tab 10.1.png": 735,
	"./Samsung Galaxy Tab 2 10.1.png": 736,
	"./Samsung Galaxy Tab 2.png": 737,
	"./Samsung Galaxy Tab S2.png": 738,
	"./Samsung Nexus S.png": 739,
	"./Samsung Z3.png": 740,
	"./Sony Xperia C4 Dual.png": 741,
	"./Sony Xperia E4 Dual.png": 742,
	"./Sony Xperia M4.png": 743,
	"./Sony Xperia T2 Ultra Dual.png": 744,
	"./Sony Xperia X.png": 745,
	"./Sony Xperia Z.png": 746,
	"./Sony Xperia Z1.png": 747,
	"./Sony Xperia Z3 Plus.png": 748,
	"./Sony Xperia Z3.png": 749,
	"./Sony Xperia Z4.png": 750,
	"./Sony Xperia Z5.png": 751,
	"./Toshiba AT100.png": 752,
	"./Toshiba Encore 2 Write.png": 753,
	"./Toshiba Excite Go.png": 754,
	"./Toshiba Thrive.png": 755,
	"./VIVO Y51L.png": 756,
	"./ViewSonic VX2452mh.png": 757,
	"./Xiaomi Mi 4i.png": 758,
	"./Xiaomi Mi Note.png": 759,
	"./Xiaomi Redmi Note 3.png": 760,
	"./Xiaomi Redmi Note 7.png": 761,
	"./Xiaomi Redmi Note 8 Pro.png": 762,
	"./Xiaomi Redmi Note 8.png": 763,
	"./Xiaomi Redmi Note 9 Pro.png": 764,
	"./Xiaomi Redmi Note 9.png": 765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;